import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { setAllEntities, withEntities } from '@ngrx/signals/entities';
import { MgsWebApi } from '../../mgs-webapi.service';
import { computed, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IKidsTermin, IKidsTermineAnzahlDaten, kidsTerminInfo } from '@mng/mgs-lib';
import { IOption, withEmptyOption } from '@mng/mng-inputs';

export interface IKidsTermineState {
  anzahlDaten: IKidsTermineAnzahlDaten;
}

export const KidsTermineStore = signalStore(
  { providedIn: 'root' },

  withState<IKidsTermineState>({ anzahlDaten: undefined }),
  withEntities<IKidsTermin>(),
  withComputed((state) => {
    const options = computed(() =>
      state.entities()?.map((termin: IKidsTermin) => ({ value: termin.id, name: kidsTerminInfo(termin) }) as IOption)
    );
    const optionsWithEmpty = computed(() => withEmptyOption(options()));
    return {
      loaded: computed(() => state.entities()?.length > 0),
      entitiesCopy: computed(() => structuredClone(state.entities())),
      options,
      optionsWithEmpty
    };
  }),

  withMethods((state) => {
    const webApi = inject(MgsWebApi);

    const load = async (force = false) => {
      const hasToLoad = force || !state.entities()?.length;
      if (hasToLoad) {
        const termine = await firstValueFrom(webApi.kidsTermine());
        patchState(state, setAllEntities(termine));
      }
    };

    const loadAnzahlDaten = async () => {
      patchState(state, { anzahlDaten: await firstValueFrom(webApi.kidsTermineAnzahlDatenErmittlung()) });
    };

    const update = async (termin: IKidsTermin) => {
      termin = await firstValueFrom(webApi.kidsTerminSpeichern(termin));
      // Termine einfach neu laden,
      // es kann sich z.B. durch eine Erhöhung der Kinderzahl für den Termin
      // auch bei anderen Termineb etwas ändern ( wenn z.B. Wartelisten abgearbeitet werden)
      await reset();
    };

    const reset = async () => {
      await load(true);
      await loadAnzahlDaten();
    };

    return {
      load,
      loadAnzahlDaten,
      update,
      reset
    };
  })
);

export type KidsTermineStore = InstanceType<typeof KidsTermineStore>;
